import * as storage from '@inqool/uas-web-core/es/utils/storage';

import { fetch as metrofetch } from '@utils/utils';

export const getGisToken = ({ addError }) => async () => {
  try {
    const response: any = await metrofetch('/metropolis/api/common/geoserver/credentials', {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });
    if (response.ok) {
      const { username, password } = await response.json();

      const gisToken = btoa(`${username}:${password}`);
      return gisToken;
    }
    return null;
  } catch {
    addError('Vaše role nemá práva pro čtení polohy.');
    return null;
  }
};

export const getImageBlob = async url => {
  const gisToken = storage.get('gistoken');
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Basic ${gisToken}`,
      'content-type': 'text/plain'
    }
  });
  if (response.ok) {
    const blob = await response.blob();
    return blob;
  } else {
    throw new Error(response.statusText);
  }
};



// WEBPACK FOOTER //
// ./src/components/map/_mapActions.ts